/**
 * Created by alvinoktavianus on 6/21/17.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updatePaymentStatus } from 'actions/billingRedirect';

class BillingRedirect extends Component {
  componentDidMount() {
    const {
      order_id,
      status_code,
      transaction_status,
    } = this.props.location.query;
    this.props.dispatch(
      updatePaymentStatus(order_id, status_code, transaction_status)
    );
  }

  render() {
    return <div />;
  }
}

export default connect()(BillingRedirect);
